import Header from './Header';

const CreatePassword = () => {
    return (
        <div className="best">
            <Header />
         <div className="bredcrub">
            <div className="container">
                <ul>
                    <li><a href="#">Home</a></li> <i className="fa-solid fa-angle-right"></i>
                    <li><a href="#">Register</a></li> <i className="fa-solid fa-angle-right"></i>
                    <li>Create Password</li>
                </ul>
            </div>
        </div>

        <div className="otpbox">

            <form action="#" className="form-group">
                <input type="text" placeholder="Password" className="passwordbox lessbott" />
                <p className="subtext">Must be 8 characters</p>
                <input type="text" placeholder="Confirm Password" className="passwordbox lessbott" />
                <p className="subtext">Both passwords must match</p>

            </form>

            <div className="checkboxarea">
                <label className="control control--checkbox">Get updates on Whatsapp<input type="checkbox" checked="" />
                    <div className="control__indicator"></div>
                </label>

                <label className="control control--checkbox">I agree with ZeoNutra’s <a href="">terms & conditions</a><input
                        type="checkbox" checked="" />
                    <div className="control__indicator"></div>
                </label>
            </div>

            <a href="#" type="submit" className="btn btn-primary otpbtn"><i>SIGN UP</i></a>


            <p className="passbottominfo">Already Register?<a href=""> Sign In</a></p>
        </div>
        </div>
    );
};
  
export default CreatePassword;